
import { LOCAL_STORAGE_ITEM } from '@/utils/constants'
import { ConfigId, isBulkReadableHT, isKeyenceEnterpriseBrowser, KeyenceModule } from '@/utils/keyenceHT/keyenceModules'
import { Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

export default class ScannerConfig extends Vue {
  @Prop({ type: String }) scannerConfigName?: string = 'ScannerConfig'
  @Prop({ type: Boolean }) shouldBulkMode?: boolean = false
  aimerTarget = 'CENTER'
  aimerTargetStorageKey = `${LOCAL_STORAGE_ITEM.KEYENCE_SCANNER_CONFIG_AIMER_TARGET}-on-${this.scannerConfigName || ''}`
  isExpanding = false
  isExpandingStorageKey = `${LOCAL_STORAGE_ITEM.KEYENCE_SCANNER_CONFIG_ISEXPANDING}-on-${this.scannerConfigName || ''}`
  aimerTargetOptions = [
    { label: 'keyenceModule.scanConfig.aimerTarget.center', value: 'CENTER' },
    { label: 'keyenceModule.scanConfig.aimerTarget.horizontal', value: 'HORIZONTAL_LINE' },
    { label: 'keyenceModule.scanConfig.aimerTarget.firstDetected', value: 'DISABLE' },
  ] as LabelOption[]

  get isEnterpriseBrowser() {
    return isKeyenceEnterpriseBrowser()
  }

  async mounted() {
    this.loadSelectionFromLocalStorage()
    this.setOption()
  }

  onOptionChange() {
    this.setOption()
  }

  setOption() {
    const currentConfig = KeyenceModule.Scanner.getConfig(ConfigId.ScanParams) as {}
    const aimerTargetOption = {
      ...currentConfig,
      ...{
        target: {
          aimerTarget: this.aimerTarget,
          decodeArea: 'NORMAL',
          scanningFormat: '',
        },
        trigger: {
          continuousMode: {
            redundancyTimeout: 2000,
            successCodesCounter: {
              count: 2,
              enable: false,
            },
          },
          scannerRendencyTimeout: 3,
          scannerTimeout: 25,
          triggerMode: this.shouldBulkMode && isBulkReadableHT ? 'CONTINUOUS' : 'NORMAL',
        },
      },
    }
    KeyenceModule.Scanner.setConfig(ConfigId.ScanParams, aimerTargetOption)
    this.saveSelectionToLocalStorage()
  }

  handleExpanding() {
    this.isExpanding = !this.isExpanding
    this.saveSelectionToLocalStorage()
  }

  saveSelectionToLocalStorage() {
    localStorage.setItem(this.aimerTargetStorageKey, this.aimerTarget)
    localStorage.setItem(this.isExpandingStorageKey, this.isExpanding.toString())
  }

  loadSelectionFromLocalStorage() {
    const savedIsExpanding = localStorage.getItem(this.isExpandingStorageKey)
    this.isExpanding = savedIsExpanding === 'true'
    const savedAimerTarget = localStorage.getItem(this.aimerTargetStorageKey)
    this.aimerTarget = savedAimerTarget || this.aimerTargetOptions[0].value
  }
}

type LabelOption = {
  label: string
  value: string
}
